export const installationRules = {
    climOnly: {
        rule: {
            element: "genreInstallationId",
            values: [3]
        }
    },
    solidOnly: {
        rule: {
            element: "genreInstallationId",
            values: [4]
        }
    },
    isGaz: {
        rule: {
            element: "genreInstallationId",
            values: [2]
        }
    },
    gazMazoutOnly: {
        rule: {
            element: "genreInstallationId",
            values: [1, 2],
        }
    },
    pompeOnly : {
        rule: {
            element: "genreInstallationId",
            values: [5],
        }
    },
    etage: {
        rule: {
            element: "genreInstallationId",
            values: [2, 3],
        }
    },
    typeInstallation: {
        rule: {
            element: "genreInstallationId",
            values: [1, 2, 4],
        }
    },
    typeCombustible: {
        rule: {
            element: "genreInstallationId",
            values: [2, 4],
        }
    },
    typeChaudiere: {
        rule: {
            element: "genreInstallationId",
            values: [1, 2, 4],
        }
    },
    puissanceChaudiere: {
        rule: {
            element: "genreInstallationId",
            values: [1, 2, 4],
        }
    },
    modeFonctionnementPompe2: {
        rule: {
            element: "modeFonctionnementPompe",
            values: [2],
        }
    },
    modeFonctionnementPompe3: {
        rule: {
            element: "modeFonctionnementPompe",
            values: [3],
        }
    },
    certifFume2: {
        rule: {
            element: "certifFume2",
            values: [1],
        }
    }
}
